import {Action, Dispatch} from 'redux';
import {EnquiryByIdAndChassisNumber, EnquiryByQrCode, SearchInput} from '../../Config/dataModel';
import enquiryAPI from '../APIs/enquiryAPI';
import userManagementAPI from '../APIs/userManagementAPI';

const TYPES = {
    FETCH_ALL_INSURERS_SUCCESS: 'FETCH_ALL_INSURERS_SUCCESS',
    ENQUIRY_SUCCESS: 'ENQUIRY_SUCCESS',
    SEARCH_SUCCESS: 'SEARCH_SUCCESS'
};

const fetchAllInsurers = () => {
    return function (dispatch: Dispatch<Action>) {
        return userManagementAPI.allInsurers().then(res => {
            dispatch(storeAllInsurers(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const enquiryByIdAndChassisNumber = (data: EnquiryByIdAndChassisNumber) => {
    return function (dispatch: Dispatch<Action>) {
        return enquiryAPI.enquiryByIdAndChassisNumber(data).then(res => {
            dispatch(storeEnquiryResult(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const enquiryByQrCode = (data: EnquiryByQrCode) => {
    return function (dispatch: Dispatch<Action>) {
        return enquiryAPI.enquiryByQrCode(data).then(res => {
            dispatch(storeEnquiryResult(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const search = (data: SearchInput) => {
    return function (dispatch: Dispatch<Action>) {
        return enquiryAPI.search(data).then(res => {
            dispatch(storeSearchResult(res.data));
        }).catch(error => {
            throw(error);
        });
    };
};

const storeAllInsurers = (data: object) => {
    return {
        type: TYPES.FETCH_ALL_INSURERS_SUCCESS,
        allInsurers: data
    };
};

const storeEnquiryResult = (data: object) => {
    return {
        type: TYPES.ENQUIRY_SUCCESS,
        enquiryResult: data
    };
};

const storeSearchResult = (data: object) => {
    return {
        type: TYPES.SEARCH_SUCCESS,
        searchResult: data
    };
};

export {TYPES, fetchAllInsurers, enquiryByIdAndChassisNumber, enquiryByQrCode, search};


// WEBPACK FOOTER //
// ./src/ReduxRequests/Actions/enquiryAction.ts